import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnChanges
} from "@angular/core";
import { ChartOptions, ChartType, ChartDataSets } from "chart.js";
import { Label } from "ng2-charts";
import * as pluginDataLabels from "chartjs-plugin-datalabels";
import { MCause } from "src/app/shared/models/cause.model";
import { TranslateService } from "@ngx-translate/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MCauseArray } from "src/app/shared/models/cause-array.model";
import * as CanvasJS from "../../../../../assets/canvasjs.min";

@Component({
  selector: "app-method-pareto",
  templateUrl: "./method-pareto.component.html",
  styleUrls: ["./method-pareto.component.scss"]
})
export class MethodParetoComponent implements OnInit, OnChanges {
  @Input() method: any;
  @Input() data: MCause[];
  @Input() readOnly: boolean = false;

  @Output() emitCauses = new EventEmitter();
  @Output() removeMethod = new EventEmitter();
  @Output() updateMethod = new EventEmitter();

  constructor(
    private translate: TranslateService,
    private modalService: NgbModal
  ) {}

  public causes: MCause[] = [];
  public editing: boolean = false;
  public magnitude: string = "";
  public title: string = "";
  public xAxysName: string = "";
  public showCanvas: boolean = true;
  public chart : any;
  ngOnInit() {
    this.translate.setDefaultLang("es");
    // this.loadCauses()
    console.log(this.data,'tetst')
  }

  ngOnChanges() {
    // console.log(this.data)
    this.loadCauses();
  }

  public loadCauses() {
    if (this.data) {
      if (this.data.length > 0) {
        // console.log(3)

        this.causes = this.data;
        // console.log(this.causes)
        if (this.causes[0].diagramData) {
          this.title = this.causes[0].diagramData.title;
          this.magnitude = this.causes[0].diagramData.magnitude;
          this.xAxysName = this.causes[0].diagramData.xAxys;
        }
        this.showCanvas = true;
        setTimeout(() => {
          this.generateBarChartData();
        }, 100);
      } else {
        // console.log(2)
        this.addCause();
      }
    } else {
      // console.log(1)
      this.addCause();
      // console.log(this.causes)
    }
  }

  metodoModal() {
    // console.log('hola');
  }

  remove(data) {
    this.removeMethod.emit(data);
    this.updateMethod.emit(false);
  }

  public generateBarChartData() {
    // if (this.causes.length > 0 && this.showCanvas){
    let organizedCauses: MCause[] = [];
    this.causes.forEach(element => {
      organizedCauses.push(element);
    });
    organizedCauses.sort((a, b) => {
      if (a.magnitude > b.magnitude) return -1;
      else if (b.magnitude > a.magnitude) return 1;
      return 0;
    });

    let data1 = {
      type: "column",
      dataPoints: []
    };
    let data2 = {
      type: "line",
      axisYType: "secondary",
      maximum: 100,
      tickColor: "#75071f",
      color: "#930a28",
      dataPoints: []
    };

    let total: number = 0;

    for (let i = 0; i < organizedCauses.length; i++) {
      let blueBg: boolean = false;
      if (this.borderline() > total || i == 0) {
        blueBg = true;
      }
      total += organizedCauses[i].magnitude;

      data1.dataPoints.push({
        y: organizedCauses[i].magnitude ? organizedCauses[i].magnitude : 0,
        label:
          organizedCauses[i].description !== ""
            ? organizedCauses[i].description
            : this.translate.instant("treatment.methods.newCause"),
        color: blueBg ? "#126DB3" : "darkgray"
      });

      data2.dataPoints.push({
        y: (total / this.totalMagnitudes()) * 100,
        label:
          organizedCauses[i].description !== ""
            ? organizedCauses[i].description
            : this.translate.instant("treatment.methods.newCause"),
        lineColor: "#cc0316"
      });
    }

    this.chart = new CanvasJS.Chart("chartContainer", {
      animationEnabled: true,
      exportEnabled: true,
      title: {
        text:
          this.title !== ""
            ? this.title
            : this.translate.instant("treatment.methods.pareto.diagram"),
        fontColor: "#126DB3"
      },
      axisY: {
        title:
          this.magnitude !== ""
            ? this.magnitude
            : this.translate.instant("treatment.methods.pareto.magnitude"),
        lineColor: "#930a28",
        tickColor: "#75071f",
        labelFontColor: "#4F81BC"
      },
      axisY2: [
        {
          title: this.translate.instant("treatment.methods.pareto.percent"),
          suffix: "%",
          stripLines: [
            {
              value: 80,
              color: "#ffffff",
              thickness: 5,
              opacity: 1
            },
            {
              value: 80,
              color: "#0e8b73",
              lineDashType: "dash",
              thickness: 3
            }
          ]
        }
      ],
      axisX: {
        tickColor: "#75071f",
        title:
          this.xAxysName !== ""
            ? this.xAxysName
            : this.translate.instant("treatment.methods.causes")
      },
      data: [data1, data2]
    });
    this.chart.render();
    setTimeout(()=>{
      this.emitData();
    }, 1000);
    // }
  }

  public addCause(title: string = "") {
    this.causes.push(
      new MCause({
        regular: {
          descripcion: title ? title : "",
          id: null,
          metodo_analisis: {
            id: 3,
            nombre: "treatment.methods.pareto.title"
          },
          magnitud: 0
        }
      })
    );

    this.checkValidity();
    setTimeout(() => {
      this.generateBarChartData();
    }, 10);
  }

  public deleteCause(modal, index: number) {
    this.modalService.open(modal, { centered: true }).result.then(
      () => {
        this.causes.splice(index, 1);
        this.checkValidity();
        this.generateBarChartData();
      },
      () => {}
    );
  }

  public emitData() {
    var total: number = 0;
    let organizedCauses: MCause[] = [];
    console.log("pareto causes",this.causes);

    this.causes.forEach(element => {
      organizedCauses.push(element);
    });
    organizedCauses.sort((a, b) => {
      if (a.magnitude > b.magnitude) return -1;
      else if (b.magnitude > a.magnitude) return 1;
      return 0;
    });

    let definitiveCauses: MCause[] = [];
    let allCauses: MCauseArray[] = [];
    allCauses.push(new MCauseArray([]));
    for (let i = 0; i < organizedCauses.length; i++) {
      organizedCauses[i].diagramData = {
        magnitude: this.magnitude,
        title: this.title,
        xAxys: this.xAxysName,
        base64: i == 0 ? this.chart.canvas.toDataURL('image/jpeg') : ''
      };
      if (
        organizedCauses[i].description !== "" &&
        !isNaN(organizedCauses[i].magnitude)
      ) {
        console.log("paretto",organizedCauses[i]);

        // organizedCauses[i].selected = true;
        organizedCauses[i].definitiveSelected = organizedCauses[i].definitiveId
          ? true
          : true;
        allCauses[0].causes.push(organizedCauses[i]);
        if (this.borderline() > total || i == 0) {
          definitiveCauses.push(organizedCauses[i]);
        }
        total += organizedCauses[i].magnitude;
      }
    }
    this.emitCauses.emit({
      data: {
        definitive: definitiveCauses,
        causes: allCauses
      },
      id: 3
    });
  }

  private totalMagnitudes(): number {
    let num = 0;
    if (this.causes) {
      if (this.causes.length > 0) {
        this.causes.forEach(cause => {
          num += cause.magnitude ? cause.magnitude : 0;
        });
      }
    }
    return num > 0 ? num : 1;
  }

  private borderline(): number {
    return this.totalMagnitudes() * 0.8;
  }

  private checkValidity() {
    // console.log(this.checkAmount())
    if (this.causes.length >= 1) {
      if (this.checkAmount() > 0) {
        this.showCanvas = true;
      } else this.showCanvas = false;
    } else this.showCanvas = false;
  }

  public onBlur(evt = null, cause: MCause = null) {
      if(evt && cause && cause.magnitude !== 0){
        cause.magnitude = this.parse(cause.magnitude);
        evt.target.value = cause.magnitude
        // console.log(cause.magnitude)
      }
    this.checkValidity();
    this.generateBarChartData();
  }

  private checkAmount(): number {
    let num: number = 0;
    this.causes.forEach(cause => {
    //   console.log(cause);
    //   cause.magnitude = parseInt(cause.magnitude.toString());
      console.log(cause);
      num += cause.magnitude;
    });
    // this.causes.forEach(c => {
    //     num+=parseInt("c.magnitude")
    // })
    return num;
  }

  public parse(num:number):number{
      return  parseFloat(num.toString())
  }
}
